export type Rarity = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary' | 'mythic'

export const RARITY_RU: Record<Rarity, string> = {
  common: 'обычное',
  uncommon: 'необычное',
  rare: 'редкое',
  epic: 'эпическое',
  legendary: 'легендарное',
  mythic: 'мифическое',
}

/** CSS class that sets --rar for frames, list stripes and item cards. */
export function rarityClass(rarity?: string): string {
  return rarity && rarity in RARITY_RU ? `r-${rarity}` : 'r-common'
}
